import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    Box,
    Typography
} from '@mui/material';
import ExamReport from './ExamReport';
import "./ReportPage.css";

const EmployeeReportDialog = ({ open, onClose }) => {
    const [employees, setEmployees] = useState([]);
    const [exams, setExams] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState('');
    const [selectedExams, setSelectedExams] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedUserGuid, setSelectedUserGuid] = useState(null);
    const [reportPayload, setReportPayload] = useState(null);


    useEffect(() => {
        if (open) {
            fetchEmployees();
            setSelectedEmployees('');
            setSelectedExams([]);
            setExams([]);
        }
    }, [open]);

    const fetchEmployees = async () => {
        try {
            const response = await axios.get('/coordinators/employees-list/',{
                withCredentials: true
            });
            const data = response.data;

            if (data.success) {
                setEmployees(data.data || []);
            }
        } catch (error) {
            console.error('Error fetching employees:', error);
        }

    };

    const fetchExams = async (guids) => {
        try {
            const examsData = [];
            for (const guid of guids) {
                const response = await axios.post('/reports/exams_by_employees/', { GUID: guid },{
                withCredentials: true
            });
                const data = response.data;

                if (Array.isArray(data)) {
                    examsData.push(...data);
                }
            }
            setExams(examsData);
        } catch (error) {
            console.error('Error fetching exams:', error);
        }
    };


    const handleEmployeeChange = (event) => {
        // const selected = event.target.value;
        // setSelectedEmployees(selected);
        // if (selected.length > 0) {
        //     const guids = selected.map(empId =>
        //         employees.find(emp => emp.Id === empId)?.GUID
        //     ).filter(Boolean);
        //     setSelectedUserGuid(guids[0]);
        //     fetchExams(guids);
        // } else {
        //     setExams([]);
        //     setSelectedExams([]);
        // }

        const selected = event.target.value;
        setSelectedEmployees(selected); 
        
         setSelectedExams([]);
         setExams([]);
        const emp = employees.find(e => e.GUID === selected);
        if (emp) {
            setSelectedUserGuid(emp.GUID);
            console.log("Fetching exams for GUID:", emp.GUID);
            fetchExams([emp.GUID]);       // <-- array because your code expects array
        } else {
            setExams([]);
            setSelectedExams([]);
        }

    };

    const handleExamChange = (event) => {
        setSelectedExams(event.target.value);
    };


    const handleGenerate = () => {

        const exam_data = selectedExams.map(examId => {
            const exam = exams.find(e => e.ExamEmployeeId === examId);
            return {
                ee_id: exam.ExamEmployeeId,
                exam_type: exam.ExamTypeId
            };
        });

        const payload = {
            user_guid: selectedEmployees,
            exam_data: exam_data,
        };

        console.log("PAYLOAD SENT TO ExamReport:", payload);

        setReportPayload(payload);
        onClose();
        setIsModalOpen(true);
        console.log('Selected Assessment Employee IDs:', selectedExams);
        // Add your API call here for the final report generation

    };

    // const getEmployeeDisplayText = () => {
    //     if (selectedEmployees.length === 0) return 'Select Employees';
    //     return selectedEmployees.map(empId => {
    //         const emp = employees.find(e => e.Id === empId);
    //         return emp ? `${emp.EmployeeId} - ${emp.EmployeeName}` : '';
    //     }).join(', ');
    // };

    const getEmployeeDisplayText = () => {
    if (!selectedEmployees) return 'Select Employee';

    const emp = employees.find(e => e.GUID === selectedEmployees);

    return emp
        ? `${emp.EmployeeId || ''} - ${emp.EmployeeName}`
        : 'Select Employee';
};

    const getExamDisplayText = () => {
        if (selectedExams.length === 0) return 'Select Assessments';
        return selectedExams.map(examId => {
            const exam = exams.find(e => e.ExamEmployeeId === examId);
            return exam ? exam.ExamTitle : '';
        }).join(', ');
    };

    return (

        <>
            {isModalOpen && (
                <div className="report-modal-backdrop" onClick={() => setIsModalOpen(false)}>
                    <div className="report-modal-content" onClick={(e) => e.stopPropagation()}>
                        {/* Close Button */}
                        <button
                            className="report-close-btn"
                            onClick={() => setIsModalOpen(false)}
                        >
                            ×
                        </button>

                        {/* Isolated Full Report */}
                        <div className="report-container">
                            <ExamReport payload={reportPayload} />
                        </div>
                    </div>
                </div>
            )}


            <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
                <DialogTitle>Generate Employee Report</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
                        <FormControl fullWidth>
                            <Typography variant="subtitle2" gutterBottom>Select Employees</Typography>
                            <Select
                                value={selectedEmployees}
                                onChange={handleEmployeeChange}
                                renderValue={getEmployeeDisplayText}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            maxHeight: 300,
                                            overflow: 'auto'
                                        }
                                    }
                                }}
                            >
                                {employees.map((employee) => (
                                    <MenuItem key={employee.GUID} value={employee.GUID}>
                                        {/* <Checkbox checked={selectedEmployees.includes(employee.Id)} />
                                        <ListItemText
                                            primary={`${employee.EmployeeId} - ${employee.EmployeeName}`}
                                        /> */}
                                        <ListItemText primary={`${employee.EmployeeId} - ${employee.EmployeeName}`} />

                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl fullWidth>
                            <Typography variant="subtitle2" gutterBottom>Select Assessments</Typography>
                            <Select
                                multiple
                                value={selectedExams}
                                onChange={handleExamChange}
                                renderValue={getExamDisplayText}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            maxHeight: 300,
                                            overflow: 'auto'
                                        }
                                    }
                                }}
                            >
                                {exams.map((exam) => (
                                    <MenuItem key={exam.ExamEmployeeId} value={exam.ExamEmployeeId}>
                                        <Checkbox checked={selectedExams.includes(exam.ExamEmployeeId)} />
                                        <ListItemText primary={exam.ExamTitle} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="btn-negative"
                        onClick={onClose}>Cancel</Button>
                    <Button
                        className="btn"
                        onClick={handleGenerate}
                        disabled={selectedExams.length === 0}
                    >
                        Generate Report
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default EmployeeReportDialog;

